"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Remote = _interopRequireDefault(require("./Remote"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @access protected
 */
var StreamManager =
/*#__PURE__*/
function () {
  /**
   * Constructor
   * @access protected
   */
  function StreamManager() {
    _classCallCheck(this, StreamManager);

    /**
     * Shared local streams
     * @type {{*: Local}}
     */
    this.shared = {};
    /**
     * Subscribed remote streams
     * @type {{*: Remote}}
     */

    this.remote = {};
  }
  /**
   * Get a Remote stream reference
   * @param {object} streamData
   * @returns {Remote}
   */


  _createClass(StreamManager, [{
    key: "getRemote",
    value: function getRemote(streamData) {
      var remoteStream = this.remote[streamData.uid];

      if (remoteStream) {
        remoteStream.update(streamData);
      } else {
        remoteStream = new _Remote.default(streamData);
        this.remote[streamData.uid] = remoteStream;
      }

      return remoteStream;
    }
    /**
     * Get a Remote stream reference
     * @param {object} streamData
     * @returns {Remote}
     */

  }, {
    key: "getShared",
    value: function getShared(streamData) {
      // TODO: If it does not exists locally as it should, maybe we should remove it ?
      return this.shared[streamData.uid];
    }
  }]);

  return StreamManager;
}();

exports.default = StreamManager;